/**
 * @ComponentFor SaleBlockViewModel
 */
import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import { pushState } from '@polarnopyret/scope/index';
import connect from 'Shared/connect';
import SaleBlock from './SaleBlockViewModel.type';
import { GridWrap } from 'Shared/PageLayout';
import { createGridClasses } from 'Shared/grid';
import { LinkButton, ButtonTheme, ButtonHeight } from 'Shared/TextButtons';
import { H2, ResponsiveSize, TextBlock, Text, ResponsiveLineHeight } from 'Shared/SharedComponents/atoms/Typography';
import { Style, StyleOrStyleArray } from '@glitz/type';

type ConnectedPropType = {
  currentBreakpoint: number;
};

type PropType = SaleBlock & ConnectedPropType & StyledProps;
const GridWrapBase = styled(GridWrap, {
  marginTop: '48px',
})

const InnerContentWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
})

const LabelWrap = styled.div({
  textAlign: 'center',
  cursor: 'pointer'
})

const Heading = styled(H2, {
  marginBottom: '16px',
  textAlign: 'center',
  cursor: 'pointer'
})

const HeadingElement = styled(Text, {
  display: 'inline-block',
})

function SaleBlock(props: PropType) {

  const buttonScheme = props.buttonColor ? ButtonTheme.Empty : ButtonTheme.Orange;
  const styles: StyleOrStyleArray<Style> = props.buttonColor ? {
    boxShadow: `inset 0px 0px 0px 2px ${props.buttonColor}`,
    backgroundColor: props.buttonColor,
    color: '#fff'
  } : null;

  return (
    <GridWrapBase className='grid wsb'>
      <div className={createGridClasses(12, 12)}>
        <InnerContentWrap>
          <LabelWrap onClick={() => { pushState(props.linkUrl) }}>
            {props.label?.map((label, index) => (
              <TextBlock key={index} upperCase fontSize={ResponsiveSize.D14_M14}>{label}</TextBlock>
            ))}
          </LabelWrap>
          <Heading fontSize={ResponsiveSize.D64_M40} onClick={() => { pushState(props.linkUrl) }}>
            {props.heading?.map((heading, index) => (
              <HeadingElement key={index} upperCase fontSize={ResponsiveSize.Inherit}>{heading}</HeadingElement>
            ))}
          </Heading>
          <LinkButton
            to={props.linkUrl}
            text={props.linkText ?? ''}
            title={props.linkTitle ?? ''}
            theme={buttonScheme}
            display={'flex'}
            height={ButtonHeight.Sale}
            padding={{ x: 40 }}
            linkButtonCss={styles}
          />
        </InnerContentWrap>
      </div>
    </GridWrapBase>
  );
}

export default connect((state) => ({
  currentBreakpoint: state.currentBreakpoint,
}))(styled(SaleBlock));
